import { Alert, Button, Modal } from '@lifebit-ai/lds'
import React from 'react'

import {
  getRequestAdditionalInfoErrorMessage,
  getRequireAdditionalInfoModalBody,
  getRequireAdditionalInfoModalSubmitLabel,
  getRequireAdditionalInfoModalTitle
} from 'utils/additionalInfoFormCopy'

interface RequestAttestationModalProps {
  isOpen: boolean
  isLoading: boolean
  isError: boolean
  onClose: () => void
  onSubmit: () => void
}

const RequestAttestationModal = ({ isOpen, isLoading, isError, onClose, onSubmit }: RequestAttestationModalProps) => {
  return (
    <Modal
      data-testid="request-attestation-modal"
      open={isOpen}
      onCancel={onClose}
      title={getRequireAdditionalInfoModalTitle()}
      closable
      footer={
        <Button type="primary" data-testid="submit-request-attestation-button" onClick={onSubmit} loading={isLoading}>
          {getRequireAdditionalInfoModalSubmitLabel()}
        </Button>
      }
    >
      {isError && (
        <Alert showIcon type="danger">
          {getRequestAdditionalInfoErrorMessage()}
        </Alert>
      )}
      <p>{getRequireAdditionalInfoModalBody()}</p>
      <p>Once completed, the request will be resubmitted for review.</p>
    </Modal>
  )
}

export default RequestAttestationModal
